// Modiles
import { getCurrentInstance } from "vue";

const MEDIA_CACHE_KEY = "frb.path.cache";

export function DomainSubstitute(srcUrl: string): string {
  if (!srcUrl) return srcUrl;

  const frisbuyDomainPart = "frisbuy";
  const isFrisbuyDomain = srcUrl.includes(frisbuyDomainPart);
  const instance = getCurrentInstance();
  // @ts-ignore: Unreachable code error
  const embedId = instance?.proxy?.settings?.embedId;

  if (
    !embedId ||
    !isFrisbuyDomain ||
    !window.frisbuy ||
    !window.frisbuy.domains ||
    !window.frisbuy.udi ||
    typeof window.frisbuy.udi[embedId] === "undefined" ||
    typeof window.frisbuy.udi === "undefined"
  )
    return srcUrl;

  const cache = JSON.parse(localStorage.getItem(MEDIA_CACHE_KEY) || "{}");

  const parsedURL = new URL(srcUrl);

  if (cache[parsedURL.pathname]) {
    return cache[parsedURL.pathname] + parsedURL.pathname + parsedURL.search;
  }

  return (
    window.frisbuy.domains[window.frisbuy.udi[embedId]] +
    parsedURL.pathname +
    parsedURL.search
  );
}

export function SaveDomainSubstitute(
  originalUrl: string,
  substitutedUrl: string
) {
  const cache = JSON.parse(localStorage.getItem(MEDIA_CACHE_KEY) || "{}");

  cache[new URL(originalUrl).pathname] = substitutedUrl;

  localStorage.setItem(MEDIA_CACHE_KEY, JSON.stringify(cache));
}

export function RemoveDomainSubstitute(originalUrl: string) {
  const cache = JSON.parse(localStorage.getItem(MEDIA_CACHE_KEY) || "{}");

  delete cache[new URL(originalUrl).pathname];

  localStorage.setItem(MEDIA_CACHE_KEY, JSON.stringify(cache));
}
